module.exports = __webpack_public_path__ + "static/1-707842b1678964aed13b36f9169c527b.png";